import React, { useEffect, useState } from "react";
import { NavLink, Navigate, useLocation, useNavigate } from "react-router-dom";

import { ButtonM, Content, Section, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import bg from "../../styles/images/signup_bg.png";
import cat from "../../styles/images/cat.png";
import FindComponent from "../../components/login/FindComponent";
import OnePageLayout from "../../components/layout/OnePageLayout";

const FindId = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <OnePageLayout title="아이디 찾기">
      <Section>
        <Content>
          <TextDiv>
            <h3>아이디를 다음과 같은 방법으로 찾을 수 있어요!</h3>
          </TextDiv>
          <FindComponent />
        </Content>
        <DescTextDiv>
          <p>
            Mu Point 회원이 아니시라면?{" "}
            <NavLink className="col" to="/sign-up">
              회원가입 바로가기
            </NavLink>
          </p>
        </DescTextDiv>
      </Section>
    </OnePageLayout>
  );
};

export default FindId;

const DescTextDiv = styled(TextDiv)`
  padding-bottom: 3rem;
  letter-spacing: -0.42px;
  a {
    font-family: NanumSquareB;
  }
`;
